<pf-dropdown hide-arrow class="user-menu">
    <div slot="button">
        <a class="nav-link">
           
        </a>
    </div>
    <div slot="menu">
        <li class="user-header bg-primary">
           

            <p>
                <span>{{ user.email }}</span>
            </p>
        </li>
        <!-- Menu Body -->
     
        <!-- Menu Footer-->
        <li class="user-footer">
            <a [routerLink]="['/profile']" class="btn btn-default btn-flat">
                Profil
            </a>
            <a (click)="logout()" class="btn btn-default btn-flat float-right">
               Çıkış
            </a>
        </li>
    </div>
</pf-dropdown>
